import { FC, PropsWithChildren } from 'react';

import { SizedBox } from '@eneco/custom-components/CircledNumber';
import { Stack, Stretch, Text } from '@eneco/sparky';
import { BoxProps, FeedbackColors } from '@eneco/sparky/types';

interface Props extends PropsWithChildren {
  backgroundColor?:
    | Extract<BoxProps['backgroundColor'], 'backgroundDark'>
    | Extract<keyof FeedbackColors, 'feedbackSuccess' | 'feedbackWarning' | 'feedbackError'>;
}

export const CircledNumber: FC<Props> = ({ backgroundColor, children }) => (
  <SizedBox borderRadius="round" backgroundColor={backgroundColor || 'backgroundDark'}>
    <Stretch>
      <Stack alignY="center">
        <Text size="BodyXL" weight="bold" color="textInverted" align="center">
          {children}
        </Text>
      </Stack>
    </Stretch>
  </SizedBox>
);
